export const SHOPEE_MAPPING_REQUIRED_STATES = new Set([
  "missing_sku",
  "unmatched",
  "duplicate_sku",
  "ambiguous_sku",
  "sku_not_found",
  "conflict"
]);

const normalizedState = value =>
  String(value || "none")
    .trim()
    .toLowerCase();

export const getShopeeMappingStatus = row => {
  const source = row || {};
  const conflictState = normalizedState(source.conflict_state);
  if (source.sync_enabled === false) return "disabled";
  if (SHOPEE_MAPPING_REQUIRED_STATES.has(conflictState)) {
    return "mapping_required";
  }
  if (
    source.last_sync_error ||
    (conflictState && conflictState !== "none")
  ) {
    return "error";
  }
  if (!source.product_id) return "mapping_required";
  if (Number(source.platform_stock || 0) <= 0) return "out_of_stock";
  return "healthy";
};

export const mappingHasSyncError = row =>
  getShopeeMappingStatus(row) === "error";

export const SHOPEE_MAPPING_STATUS_LABEL_IDS = {
  disabled: "shopee.workspace.mapping.status.disabled",
  error: "shopee.workspace.mapping.status.error",
  healthy: "shopee.workspace.mapping.status.healthy",
  mapping_required: "shopee.workspace.mapping.status.mapping-required",
  out_of_stock: "shopee.workspace.mapping.status.out-of-stock"
};

export const shopeeMappingStatusLabel = status =>
  SHOPEE_MAPPING_STATUS_LABEL_IDS[status] ||
  "shopee.workspace.orders.status-unknown";
